import createBrowserHistory from 'history/createBrowserHistory'
const history = createBrowserHistory()
export default history



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/history.ts